module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_12"
    }
  })])]), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Tables")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "10%"
    }
  }), _c('col')]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#tab-003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.1.")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#tab-003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetorical Inclusio Between Hebrews 4:14-16 and Hebrews 10:19-23")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#tab-004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.2.")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#tab-004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pairs of teaching from Hebrews 6:1-2")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#tab-005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.1.")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#tab-005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Revelatory Disclosures of Jesus’ Baptism, Transfiguration, and Crucifixion")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#tab-006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.2.")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#tab-006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Disclosure Moments at Caesarea Philippi and the Jerusalem Sanhedrin Meeting")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#tab-007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.3.")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#tab-007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parallels Between Peter and Paul in Acts")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#tab-008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.4.")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#tab-008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luke Passages Showing Fulfillment of Isaiah 6:1-2")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#tab-009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.5.")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap6#tab-009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comparison of Luke’s Sermon on the Plain with Matthew’s Sermon on the Mount")])])])]), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#tab-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.1.")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap7#tab-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Comparison of Jude and 2 Peter")])])])])])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Figures")])]), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-002"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "10%"
    }
  }), _c('col')]), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.1.")])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("History as Two Funnels")])])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 69
// module chunks = 0